import 'core-js/es6/promise';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/array';
import 'core-js/fn/object/assign';
import 'core-js/fn/string/includes';
import 'url-search-params-polyfill';
import 'raf/polyfill';
import 'whatwg-fetch';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'blob-polyfill';

import React from 'react';
import { render } from 'react-dom';

import { createTemplatePrototype } from '@biw/contests-core/lib/dux/progress/utils';
import { fetchMiddleware } from '@biw/client-fetch';
import { fetch } from '@biw/contests-core';

// uncomment to enable in dev
// import { whyDidYouUpdate } from 'why-did-you-update';
// whyDidYouUpdate( React );

import createStore from './store';

import './framework/scss/style.scss';

import App from './app';

const AppStore = createStore();

fetchMiddleware.onFetching.push( options => AppStore.dispatch( fetch.actions.fetching( options.type ) ) );
fetchMiddleware.onFetched.push( options => AppStore.dispatch( fetch.actions.fetched( options.type ) ) );
fetchMiddleware.onFetchingError.push( ( options, error, results ) => AppStore.dispatch( fetch.actions.fetchingError( options.type, error, results ) ) );

render(
    <App store={AppStore} />,
    document.getElementById( 'app-root' )
);

createTemplatePrototype();

// Conditionally enable hot module reloading
/* istanbul ignore next */
if ( module.hot ) {
    module.hot.accept();
}
